var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 28C30.0001 29.1046 29.1047 30 28.0001 30C26.8956 30 26.0001 29.1046 26.0001 28C26.0001 26.8954 26.8956 26 28.0001 26C29.1047 26 30.0001 26.8954 30.0001 28Z",
    fill: "#3B6CF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0001 19C22.4086 19 17.7103 22.8243 16.3782 28C17.7103 33.1757 22.4086 37 28.0001 37C33.5916 37 38.2899 33.1757 39.6221 28C38.2899 22.8243 33.5916 19 28.0001 19ZM32.0001 28C32.0001 30.2091 30.2093 32 28.0001 32C25.791 32 24.0001 30.2091 24.0001 28C24.0001 25.7909 25.791 24 28.0001 24C30.2093 24 32.0001 25.7909 32.0001 28Z",
    fill: "#3B6CF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "none",
    stroke: "#F3F5FB",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveEye);
export default __webpack_public_path__ + "static/media/wave-eye.2c9c32a147ea92e4cf6abea5bec451ae.svg";
export { ForwardRef as ReactComponent };